import { Component, Vue } from 'vue-property-decorator';
import KEYS from '@/values/keys';
import { STORE } from '@/core/store/core.store';
import EdContentSection from '../components/ed-content-section/ed-content-section.vue';
import EdContentSectionLoading from '../components/ed-conten-section-loading/ed-content-section-loading.vue';
import EdContentItem from '../components/ed-content-item/ed-content-item.vue'
import { FOOTER_TYPE } from '@/core/values/core.values';
import { ALL_CONTENT_ROUTES } from '../views/all/all.router';
import { FILESCACHE_KEYS } from '@/shared/plugins/files-cache/enums/files-cache.enum';
import Content from '@/content/models/content.model';
import { WORKER_EVENT_BUS } from '@/core/enums/worker.enum';
import { MY_CONTENT_STORE } from '../store/my-content.store';
import { BUILDER_STATUS } from '@/courses/values/courses.values';
import { CONTENT_TYPE } from '@/classes/values/classes.values';

@Component({
  components: {
    EdContentSection,
    EdContentSectionLoading,
    EdContentItem,
  },
})
export class MyContentViewsMixin extends Vue {

  /* Data */
  public page: string = '';
  public isCoursesLoading: boolean = false;
  public isCoursesLoadingMore: boolean = false;
  public limit: number = Math.floor(window.innerWidth / 200);

  /* Computed */
  get courses() {
    return this.$store.state.MyContentStore[this.page].courses.content;
  }

  /* Methods */
  async getCourses(isCoursesLoading = true) {
    this.isCoursesLoading = isCoursesLoading;
    let builderContent = [];
    if(this.page === 'subjects') {
      await this._getBuilderDataFromStore(builderContent);
    }
    return this.$store.dispatch(STORE.MY_CONTENT.ACTIONS.GET_CONTENT, {
      type: 'courses',
      code: KEYS.CONTENT_TYPE.COURSE,
      builderContent: builderContent
    })
    .finally(() =>  this.isCoursesLoading = false);
  }

  async _getBuilderDataFromStore(builderContent) {
    const data = await Vue.prototype.$BuilderCache.getDataByPrefix('builder_', FILESCACHE_KEYS.BUILDER_DATA);
    if (data) {
      data
        .sort((a, b) => b.builderId - a.builderId)
        .forEach(item => {
          const builderId = item.builderId;
          const id = item.subject.id;
          item.subject.fromId = (item.subject.type === CONTENT_TYPE.TEMPLATE) ? id : item.builderId;
          item.subject.id = (BUILDER_STATUS.DONE === item.status) ? item.contentId : builderId;
          builderContent.push(new Content({
            ...item.subject,
            subtitle: item.subject.categoryNames,
            img: (item.coverImage) ? URL.createObjectURL(item.coverImage) : item.subject.img,
            authorsNames: item.subject.authorString ?? this.$store.state.AuthStore.user?.fullName,
            status: item.status,
            syncStatus: item.syncStatus,
            contentId: item.contentId,
            version: item.version,
            builderId: builderId,
            deleteLocal: true
          }));
        });
    }
  }

  async updateBuilderStatus() {
    this.$store.commit(MY_CONTENT_STORE.MUTATIONS.INIT_COURSES);
    this.getCourses();
  }      

  goToAll(type: string) {
    let page = this.$store.state.MyContentStore.pageName;
    this.$router.push({name: ALL_CONTENT_ROUTES.CONTENTS.NAME, params: { page } });
  }

  /* Hooks */
  mounted() {
    this.$store.commit(STORE.MY_CONTENT.MUTATIONS.SET_PAGE_NAME, this.page);
    this.$App.Store.changeFooterType(FOOTER_TYPE.COMMON);
    let page = this.$store.state.MyContentStore.pageName;  
    if(!this.$store.state.MyContentStore[page].courses.firstLoad) {
      this.getCourses();
    }
    this.$edEventBus.$on(WORKER_EVENT_BUS.BUILDER_STATUS, this.updateBuilderStatus);
  }

  beforeDestroy() {
    this.$edEventBus.$off(WORKER_EVENT_BUS.BUILDER_STATUS, this.updateBuilderStatus);
  }

}
